module.exports = __webpack_public_path__ + "img/choose_2.d2a4aa65.png";